<template>
  <div>
    <el-card>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item >查看销量</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20" style="margin-top:20px;">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="商品名称" prop="createTime">
              <el-input v-model="searchForm.name" placeholder="请输入商品名称" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="7">
            <el-form-item label="下单时间" prop="createTime">
              <el-date-picker
              style="width:100%"
                :clearable="false"
                v-model="createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="createTimeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-button
              type="primary"
              @click="pageList(),getGoodsInfoStats()"
              icon="el-icon-search"
            >查询</el-button>
            <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card>
          <div style="font-size:16px">总营收概况</div>
          <el-row style="margin-top:10px">
            <el-col :span="12">
              累计销量
              <div style="margin-top:10px;font-size:20px">{{goodsInfoStat.consumptionOrderCount}}</div>
            </el-col>
            <el-col :span="12">
              销售金额(元)
              <div style="margin-top:10px;font-size:20px">{{goodsInfoStat.consumptionAmount}}</div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div style="font-size:16px">{{createTime[0]}}至{{createTime[1]}}营收概况</div>
          <el-row style="margin-top:10px">
            <el-col :span="12">
              累计销量
              <div
                style="margin-top:10px;font-size:20px"
              >{{goodsInfoStat.periodConsumptionOrderCount}}</div>
            </el-col>
            <el-col :span="12">
              销售金额(元)
              <div style="margin-top:10px;font-size:20px">{{goodsInfoStat.periodConsumptionAmount}}</div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-card class="box-card" style="margin-top: 20px;">
      <el-table
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column prop="number" label="单号" width="150"></el-table-column>
        <el-table-column prop="student.name" label="学员姓名"></el-table-column>
        <el-table-column prop="student.mobile" label="电话"></el-table-column>
        <el-table-column prop="sourceType" label="订单来源"></el-table-column>
        <el-table-column prop="totalAmount" label="实付"></el-table-column>
        <el-table-column prop="paidState" label="付款方式">
          <template
            slot-scope="row"
          >{{row.row.paidState==1?row.row.orderPaymentList[0].channel:"未支付"}}</template>
        </el-table-column>
        <el-table-column prop="student.campusName" label="校区"></el-table-column>
        <!-- <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="createTime" label="下单时间" width="150"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      paidTime: [],
      createTime: [],
      orderStateForm: [],
      orderSourceForm: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      searchForm: {
        orderState: "",
        sourceType: "",
        orderTime: "",
        type: "",
        number: "",
        ip: "",
        remark: ""
      },
      formLabelWidth: "80px",
      selection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/orderInfo/upload`,
      fileList: [],
      loading: true,
      goodsId: "",
      goodsInfoStat: {}
    };
  },
  methods: {
    getGoodsId() {
      this.searchForm.goodsId = this.$route.query.goodsId;
      this.pageList();
    },
    createTimeChange() {
      if (this.createTime) {
        this.getGoodsInfoStats();
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.orderInfo
        .pageList(this.searchForm)
        .then(result => {
          if(result.success){
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
          }else{
            this.$message.error(result.message)
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addOrderInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.orderInfo
            .addOrderInfo(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateOrderInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.orderInfo
            .updateOrderInfo(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.createTime = [];
      this.searchForm.createTimeBegin = "";
      this.searchForm.createTimeEnd = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    timeMonth() {
      this.createTime = [
        moment()
          .subtract(29, "days")
          .format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ];
      this.getGoodsInfoStats();
    },
    getGoodsInfoStats() {
      let obj = {
        goodsId: this.searchForm.goodsId,
        createTimeBegin: this.createTime[0],
        createTimeEnd: this.createTime[1]
      };
      this.api.goodsInfo.getGoodsInfoStats(obj).then(result => {
        this.goodsInfoStat = result.data;
      });
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    getOrderSourceType() {
      this.api.orderInfo.getOrderSourceType().then(result => {
        this.orderSourceForm = result.data;
      });
    },
    getOrderState() {
      this.api.orderInfo.getOrderState().then(result => {
        this.orderStateForm = result.data;
      });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getGoodsId();
    this.timeMonth();
    // this.pageList();
    // this.getOrderState();
    // this.getOrderSourceType();
  }
};
</script>
<style  scoped>
.el-select {
  width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/goods/goodsNumber.vue